import { Component, OnInit } from '@angular/core';
import { CasteMasterPopupComponent } from '../caste-master-popup/caste-master-popup.component';
import { MatDialog } from '@angular/material/dialog';
import { MatDialogRef } from '@angular/material/dialog';
import { AlertBoxComponent } from '../alert-box/alert-box.component';
import { NgxSpinnerService } from 'ngx-spinner';
import { HttpErrorResponse } from '@angular/common/http';
import { UmsService } from '../ums.service';
import { ModalpopService } from '../modalpop.service';
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { PageEvent } from '@angular/material/paginator';

@Component({
  selector: 'app-caste-master',
  templateUrl: './caste-master.component.html',
  styleUrls: ['./caste-master.component.scss']
})
export class CasteMasterComponent implements OnInit {
  CasteSearchForm: FormGroup;
  dialogRef: MatDialogRef<any>;
  casteList: any[];
  pageSize = 10;
  pageSizeOptions: number[] = [5, 10, 20];
  currentPage = 1;
  totalItems = 0;
  setIntervalSearch: any;
  constructor(private dialog: MatDialog,
    private spinner: NgxSpinnerService,
    public umsService: UmsService,
    private modalPopupService: ModalpopService,
    private fb: FormBuilder,
  ) {
    
   }

  ngOnInit(): void {
    this.getCasteData();
    this.CasteSearchForm = this.fb.group({
      SearchString: new FormControl('')
    });
  }


  onPageChange(event: PageEvent): void {
    this.pageSize = event.pageSize;
    const newPageIndex = event.pageIndex + 1;
    this.currentPage = newPageIndex;
    this.getCasteData();
    this.keypress();
  }

  getCasteData() {
    // this.spinner.show();
    const payload = {};
    payload['PageSize'] = this.pageSize;
    payload['PageNumber'] = this.currentPage;
    this.umsService.getCasteData(payload).subscribe(res => {
      // this.spinner.hide();
      this.casteList = res.data;
      this.totalItems = res.data[0].TotalRecords;
    }, (ERROR: HttpErrorResponse) => {
      this.casteList = [];
      let data = {}
      this.spinner.hide();
      data['message'] = ERROR.error.message
      data['title'] = 'Information'
      data['icon'] = 'fas fa-box-open'
      this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
    });
  }

  keypress() {
    if(this.setIntervalSearch){
      clearTimeout(this.setIntervalSearch);
    }
    this.setIntervalSearch = setTimeout(()=>{
      this.casteList = [];
    let payload = {}
    payload['SearchString'] = this.CasteSearchForm.value['SearchString'];
    payload['PageSize'] = this.pageSize;
    // payload['PageNumber'] = this.currentPage;
    if (payload['SearchString'] === "") {
      payload['PageNumber'] = this.currentPage;
    } else {
      payload['PageNumber'] = 1;
    }
    this.umsService.getCasteData(payload).subscribe(res => {
      if(res.status){
        this.casteList = res.data;
        this.totalItems = res.data[0].TotalRecords;
      }
      else{
        this.casteList = [];
        this.totalItems = 0;
      }
     
    }, (ERROR: HttpErrorResponse) => {
      this.casteList = [];
    });
    },1000)
   
  }

  addnewrecord() {

    const dialogRef = this.dialog.open(CasteMasterPopupComponent, {
      width: '75vh',
      data: { key: "New" },
      disableClose: true
    });
    dialogRef.afterClosed().subscribe(result => {
      this.getCasteData();
      this.CasteSearchForm.controls['SearchString'].setValue('');
    });
  }

  editData(k) {
    const dialogRef = this.dialog.open(CasteMasterPopupComponent, {
      width: '75vh',
      data: { selected: k, key: "Edit" },
      disableClose: true
    });
    dialogRef.afterClosed().subscribe(result => {
      this.getCasteData();
      this.CasteSearchForm.controls['SearchString'].setValue('');
    });
  }

  deleteData(k) {
    const dialogRef = this.dialog.open(CasteMasterPopupComponent, {
      width: '75vh',
      data: { selected: k, key: "Delete" },
      disableClose: true
    });
    dialogRef.afterClosed().subscribe(result => {
      this.getCasteData();
      this.CasteSearchForm.controls['SearchString'].setValue('');
    });
  }

  removePipesFromCategoryId(categoryId: string): string {
    if (!categoryId) return ''; // Handle undefined or null
    return categoryId.replace(/^\|+|\|+$/g, '');
  }
}
